/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconTag16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTag16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M10.873 7.166a1.333 1.333 0 1 0-1.885-1.885 1.333 1.333 0 0 0 1.885 1.885Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.388 11.88c-.879-.878-1.318-1.317-1.521-1.807a2.667 2.667 0 0 1 0-2.041c.203-.49.642-.93 1.52-1.808l3.147-3.147c.509-.508.763-.762 1.055-.934.39-.23.831-.357 1.283-.368.34-.01.69.072 1.39.233l2.141.494c.589.136.883.204 1.13.34a2 2 0 0 1 .779.78c.136.246.204.54.34 1.129l.494 2.14c.162.701.242 1.051.233 1.39a2.668 2.668 0 0 1-.368 1.284c-.172.292-.426.546-.934 1.055L9.93 13.766c-.878.879-1.317 1.318-1.808 1.521-.653.27-1.387.27-2.04 0-.49-.203-.93-.642-1.808-1.52L2.388 11.88Zm.943-4.714L6.477 4.02c.559-.559.677-.663.789-.728.195-.115.415-.179.641-.185.13-.003.286.023 1.055.2l2.141.494c.668.154.74.184.783.207.109.061.199.151.26.26.023.043.053.115.207.783l.494 2.14c.177.77.203.926.2 1.056-.006.226-.07.446-.184.641-.066.112-.17.23-.729.789l-3.146 3.146c-.453.452-.745.744-.984.952-.23.2-.336.257-.392.28a1.334 1.334 0 0 1-1.02 0c-.056-.023-.163-.08-.392-.28-.239-.208-.531-.5-.984-.952l-1.885-1.885a22.543 22.543 0 0 1-.952-.984c-.2-.23-.257-.336-.28-.392a1.333 1.333 0 0 1 0-1.02c.023-.056.08-.163.28-.392.208-.239.5-.531.952-.984Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconTag24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTag24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M16.31 10.749a2 2 0 1 0-2.828-2.828 2 2 0 0 0 2.829 2.828Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.583 17.82c-1.318-1.318-1.977-1.977-2.281-2.712a4 4 0 0 1 0-3.061c.304-.735.963-1.394 2.28-2.712l4.72-4.72c.763-.762 1.144-1.143 1.582-1.402a4 4 0 0 1 1.926-.552c.508-.013 1.034.108 2.084.35l3.212.742c.883.203 1.324.305 1.693.51a3 3 0 0 1 1.17 1.17c.204.368.306.81.51 1.692l.74 3.212c.243 1.05.364 1.576.351 2.085a4 4 0 0 1-.552 1.925c-.258.438-.64.82-1.402 1.582l-4.72 4.72c-1.317 1.317-1.976 1.976-2.711 2.28a4 4 0 0 1-3.062 0c-.735-.304-1.394-.963-2.712-2.28L3.583 17.82Zm1.414-7.071 4.72-4.72c.838-.838 1.015-.994 1.183-1.092a2 2 0 0 1 .962-.277c.194-.005.428.034 1.582.3l3.212.741c1.001.231 1.11.275 1.174.31a1 1 0 0 1 .39.39c.035.065.079.173.31 1.174l.741 3.212c.267 1.154.305 1.388.3 1.582a2 2 0 0 1-.276.963c-.099.167-.255.345-1.093 1.183l-4.72 4.72c-.678.678-1.117 1.115-1.475 1.427-.344.3-.505.386-.588.42a2 2 0 0 1-1.53 0c-.084-.035-.244-.12-.589-.42-.358-.312-.796-.75-1.475-1.428l-2.828-2.828c-.678-.678-1.115-1.117-1.428-1.475-.3-.345-.385-.505-.42-.588a2 2 0 0 1 0-1.531c.035-.083.12-.244.42-.588.313-.358.75-.797 1.428-1.475Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconTag = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTag(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconTag16 {...iconProps} />;
        case '24':
            return <IconTag24 {...iconProps} />;
        default:
            return <IconTag24 {...iconProps} />;
    }
});
